import React, { useState } from 'react';
import 'styled-components/macro';
import Grid from 'components/atoms/Grid';
import GridCol from 'components/atoms/GridCol';
import Toast from 'components/molecules/Toast';
import merchantToolService from 'services/merchantToolService';
import { StyledMidSelection, StyledCurrentMidButton, StyledPreviousMidButton, StyledNoMidsMessage } from './styles';

function MerchantLoginModal({ onClose, business }) {
  const [loading, setLoading] = useState(false);
  const [selectedMid, setSelectedMid] = useState(null);

  const currentMid = business?.mid;
  const previousMids = business?.previous_mids || [];
  const allMids = [currentMid, ...previousMids].filter(Boolean);

  const handleLogin = async mid => {
    if (!mid) return;

    try {
      setLoading(true);
      setSelectedMid(mid);

      const businessWithSelectedMid = {
        ...business,
        mid,
      };

      const { token } = await merchantToolService.getMerchantToolToken({
        business_details: businessWithSelectedMid,
      });

      const url = `${process.env.REACT_APP_MERCHANT_TOOL_API.replace('/api', `/login?tmstoken=${token}`)}`;
      window.open(url, '_blank');

      Toast({
        type: 'success',
        message: `Logging in as merchant with MID: ${mid}`,
      });

      onClose();
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message ?? 'Failed to login as merchant',
      });
    }
    setLoading(false);
    setSelectedMid(null);
  };

  if (allMids.length === 0) {
    return (
      <Grid>
        <GridCol md={12}>
          <StyledNoMidsMessage>
            <i className="material-icons-outlined">error_outline</i>
            <h3>No MIDs Available</h3>
            <p>This business does not have any MIDs assigned. Please assign a MID first.</p>
          </StyledNoMidsMessage>
        </GridCol>
      </Grid>
    );
  }

  return (
    <Grid>
      <GridCol md={12}>
        <StyledMidSelection>
          <h3>Select MID to Login As</h3>
          <p>Choose which MID you would like to use for merchant login:</p>

          <div className="mids-container">
            {currentMid && (
              <div className="mid-section">
                <h4>Current MID</h4>
                <StyledCurrentMidButton
                  type="primary"
                  loading={loading && selectedMid === currentMid}
                  disabled={loading}
                  onClick={() => handleLogin(currentMid)}>
                  <div className="mid-info">
                    <span className="mid-value">{currentMid}</span>
                    <span className="mid-label">ACTIVE</span>
                  </div>
                </StyledCurrentMidButton>
              </div>
            )}

            {previousMids.length > 0 && (
              <div className="mid-section">
                <h4>Previous MIDs</h4>
                <div className="previous-mids">
                  {previousMids.map((mid, index) => (
                    <StyledPreviousMidButton
                      key={index}
                      type="primary"
                      loading={loading && selectedMid === mid}
                      disabled={loading}
                      onClick={() => handleLogin(mid)}>
                      <div className="mid-info">
                        <span className="mid-value">{mid}</span>
                        <span className="mid-label">PREVIOUS</span>
                      </div>
                    </StyledPreviousMidButton>
                  ))}
                </div>
              </div>
            )}
          </div>
        </StyledMidSelection>
      </GridCol>
    </Grid>
  );
}

export default MerchantLoginModal;
